// Session management utility
class SessionManager {
  static SESSION_TIMEOUT = 60 * 60 * 1000 * 3; // 3 hour in milliseconds
  static ACTIVITY_CHECK_INTERVAL = 60 * 1000 * 5; // Check every 5 minute
  static WARNING_TIME = 5 * 60 * 1000; // Show warning 5 minutes before expiry

  static updateLastActivity() {
    const now = Date.now();
    const isRemembered = localStorage.getItem('authToken');
    
    if (isRemembered) {
      localStorage.setItem('lastActivity', now.toString());
    } else {
      sessionStorage.setItem('lastActivity', now.toString());
    }
  }

  static getLastActivity() {
    return localStorage.getItem('lastActivity') || sessionStorage.getItem('lastActivity');
  }

  static getTimeSinceLastActivity() {
    const lastActivity = this.getLastActivity();
    if (!lastActivity) return 0;
    return Date.now() - parseInt(lastActivity);
  }

  static isSessionExpired() {
    const timeSinceLastActivity = this.getTimeSinceLastActivity();
    if (!this.getLastActivity()) return true;
    return timeSinceLastActivity > this.SESSION_TIMEOUT;
  }

  static getTimeUntilExpiry() {
    const timeSinceLastActivity = this.getTimeSinceLastActivity();
    return Math.max(0, this.SESSION_TIMEOUT - timeSinceLastActivity);
  }

  static shouldShowWarning() {
    const timeUntilExpiry = this.getTimeUntilExpiry();
    return timeUntilExpiry > 0 && timeUntilExpiry <= this.WARNING_TIME;
  }

  static clearSession() {
    // Clear all stored data
    localStorage.removeItem('authToken');
    localStorage.removeItem('adminUser');
    localStorage.removeItem('icer_admin_user');
    localStorage.removeItem('lastActivity');
    sessionStorage.removeItem('authToken');
    sessionStorage.removeItem('adminUser');
    sessionStorage.removeItem('icer_admin_user');
    sessionStorage.removeItem('lastActivity');
  }

  static isAuthenticated() {
    return !!(localStorage.getItem('authToken') || sessionStorage.getItem('authToken'));
  }

  static formatTimeRemaining(milliseconds) {
    const minutes = Math.floor(milliseconds / 60000);
    const seconds = Math.floor((milliseconds % 60000) / 1000);
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  }
}

export default SessionManager;